import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import { Text18Size, TitleH2, StyledButton } from "components/generic";
import { LimitWidthSection } from "../styles";
import {
  BlogGrid,
  JobDiv,
  JobTitle,
  JobSection,
  JobImg,
  ButtonSection
} from "./styles";
import { OrangePlayFull } from "components/Icons/OrangePlayFull";
import { CardVacancies } from "./CardVacancies";
import { HeaderSEO } from "components/headerSEO";
import { ISeo } from "interfaces/interfaces";
import mainImg from "assets/images/Oprichters Hospi Housing Maurits en Daan bij hospita en student thuis.webp";
import { useIsMobile } from "../../../utils/hooks/useWindowSize";
import { getVacancyData } from "../../../utils/getVacancyData";

interface IPost {
  title: string;
  url: string;
  post: number;
  text: string[];
  tags: string[];
}

export const Vacancies: React.FC = () => {
  const { t, i18n } = useTranslation("vacancies");
  const isMobile = useIsMobile();

  const [textWidth, setTextWidth] = React.useState<string>("399px");
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isMobile) {
      setTextWidth("375px");
    } else {
      setTextWidth("399px");
    }
  }, [isMobile]);

  const seo = t("vacancies.seo", { returnObjects: true }) as ISeo;

  const [myposts, setMyPosts] = useState<IPost[]>([]);
  useEffect(() => {
    async function addResourceBundle() {
      const blogData = getVacancyData(i18n.language);
      const myPosts = blogData
        .sort((a, b) => a.post - b.post) // Sort the blogData based on post number
        .reverse();
      setMyPosts(myPosts);
    }
    addResourceBundle();
  }, [i18n.language]);

  const handleNavigate = useCallback(() => {
    navigate({ search: "?f=f" }, { replace: true });
  }, [navigate]);

  useEffect(() => {
    myposts.length && handleNavigate();
  }, [handleNavigate, myposts]);
  return (
    <JobDiv>
      <JobSection>
        {seo && <HeaderSEO {...seo} />}

        <JobTitle>{t("vacancies.title")}</JobTitle>
        <OrangePlayFull
          viewView={textWidth}
          viewHeight="16px"
          marginBottom="1em"
          strokeWidth="6"
        />
        <JobImg src={mainImg} />
        <TitleH2>{t("vacancies.looking")}</TitleH2>
        <BlogGrid>
          {myposts.length &&
            myposts.map((item, j) => (
              <CardVacancies keyPost={item.url} index={j} />
            ))}
        </BlogGrid>
        <TitleH2>{t("vacancies.about")}</TitleH2>
        <LimitWidthSection>
          <Text18Size>{t("vacancies.text.0")}</Text18Size>
          <ButtonSection>
            <StyledButton>
              <NavLink to={`/${i18n.language}/mission`}>
                {t("vacancies.buttons.mission")}
              </NavLink>
            </StyledButton>
            <StyledButton>
              <NavLink to={`/${i18n.language}/team`}>
                {t("vacancies.buttons.team")}
              </NavLink>
            </StyledButton>
          </ButtonSection>
        </LimitWidthSection>
      </JobSection>
    </JobDiv>
  );
};
